import saveMailRibbonConfiguration from '../actions/saveMailRibbonConfiguration';
import updateMailRibbonConfiguration from '../mutators/updateMailRibbonConfigurationMutator';
import { getStore } from '../store/store';
import { updateUserConfigurationAndService } from 'owa-session-store';
import { orchestrator } from 'satcheljs';

/**
 * This orchestrator saves the current mail ribbon configuration into both:
 *  1) The current local store via @see {updateMailRibbonConfiguration}.
 *  2) The user's persisted store via @see {updateUserConfigurationAndService}.
 */
orchestrator(saveMailRibbonConfiguration, actionMessage => {
    const {
        mailRibbonLayout,
        controlsInOverflow,
        removedDefaultGroups,
        staticGroupIdOrdering,
        showLabelsPreference,
    } = actionMessage;

    // Saving to local store
    updateMailRibbonConfiguration(
        mailRibbonLayout,
        controlsInOverflow,
        removedDefaultGroups,
        staticGroupIdOrdering,
        showLabelsPreference
    );

    // Saving to persisted store
    const ribbonConfigString: string = JSON.stringify(getStore());
    updateUserConfigurationAndService(
        config => {
            if (config.ViewStateConfiguration) {
                config.ViewStateConfiguration.MailRibbonConfig = ribbonConfigString;
            }
        },
        [{ key: 'MailRibbonConfig', valuetype: 'String', value: [ribbonConfigString] }],
        'OWA.ViewStateConfiguration'
    );
});
